export const PodcastResourcesDA = {
  title: "TILKNYTNING",
  kicker: "Podcast",
  hosts: "Aida Bikic og Peter Krogh Andersen",
  captivate: "Lyt på Captivate",
  spotify: "Lyt på Spotify",
  paragraph1:
    "Hvorfor gentager vi vores forældres fejl, når vi selv bliver forældre? Det er fundamentet for podcasten TILKNYTNING, som med forskerbriller og journalistisk styring ser nærmere på det bånd, der dannes mellem forældre og små børn, og som spiller en enorm rolle for et menneskes trivsel og selvværd resten af livet.",
  paragraph2:
    "I hvert afsnit hører vi, hvordan forældre, pædagoger og andre omsorgspersoner kan ændre på dele af deres egen adfærd og uheldige mønstre, så barnet får den bedst mulige start på livet. Podcasten består af en introduktion og fire afsnit, som kommer i en kort og en lang version.",
  paragraph3:
    "Gæsterne er landets førende forskere og eksperter. I hvert afsnit er værterne psykolog og forsker ved Syddansk Universitet Aida Bikic og journalist Peter Krogh Andersen.",
  episodesHeading: "Afsnit",
  episodes: [
    {
      title: "Hvad kan vi lære af andre samfund?",
      duration: "46 min",
      description:
        "Forældre i de små grønlandske samfund er sammen med deres børn døgnet rundt. I afrikanske stammesamfund er hierarkiet ofte stift og hårdt, men trygt. I Danmark giver det travle storbyliv svære kår for en tryg tilknytning, og det kræver, at vi tænker familien på en ny måde. Men hvad kan Danmark lære af andre samfund rundt i verden? Gæst: Niels Peter Rygaard, psykolog, forfatter og grundlægger af Fairstart Foundation.",
    },
    {
      title: "TEASER: Hvad kan vi lære af andre samfund?",
      duration: "5 min",
      description: "Kort teaser til afsnittet.",
    },
    {
      title: "Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "41 min",
      description:
        "Kan overtræning og spiseforstyrrelser blandt voksne skyldes utryg tilknytning? Det mener forsker og psykolog Mia Beck Lichtenstein, som ofte ser, at hendes klienter tyr til ekstrem kontrol af krop og mad, når følelserne er svære. Gæst: Mia Beck Lichtenstein, psykolog og professor ved SDU.",
    },
    {
      title: "TEASER: Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "4 min",
      description: "Kort teaser til afsnittet.",
    },
    {
      title: "De atypiske hjerner er særligt sårbare",
      duration: "44 min",
      description:
        "De mange voksne i en moderne barndom giver svære kår for tryg tilknytning uden for hjemmet. Det rammer særligt børn med ADHD og andre former for atypiske hjerner, fortæller forsker og forfatter Pernille Darling. Hendes egen optælling viser, at et barn i dag møder op til 10 gange så mange voksne, som hun gjorde i sin barndom. Gæst: Pernille Darling Juul, psykiater og forsker.",
    },
    {
      title: "TEASER: De atypiske hjerner er særligt sårbare",
      duration: "3 min",
      description: "Kort teaser til afsnittet.",
    },
    {
      title: "Hvorfor gentager vi vores forældres fejl?",
      duration: "49 min",
      description:
        "De fleste af os vil gerne undgå at gentage vores forældres fejl. Alligevel ender vi med at gøre netop, som vores forældre gjorde — særligt når vi kommer under pres. Men hvorfor? Og hvad kan vi gøre for at ændre det? Gæst: Johanne Smith-Nielsen, psykolog og forsker ved Københavns Universitet.",
    },
    {
      title: "Introduktion: Hvad er tilknytning?",
      duration: "3 min",
      description:
        "Hvad ved vi egentlig om tilknytning, og hvorfor er det så vigtigt for dit barns trivsel og selvværd? En kort introduktion til båndet mellem dig og dit barn, fortalt af forsker og psykolog Aida Bikic.",
    },
    {
      title: "TEASER: Hvorfor gentager vi vores forældres fejl?",
      duration: "5 min",
      description: "Kort teaser til afsnittet.",
    },
  ],
};

export const PodcastResourcesEN = {
  title: "TILKNYTNING",
  kicker: "Podcast",
  hosts: "Aida Bikic and Peter Krogh Andersen",
  captivate: "Listen on Captivate",
  spotify: "Listen on Spotify",
  paragraph1:
    "Why do we repeat our parents' mistakes when we become parents ourselves? That question is the foundation of the podcast TILKNYTNING, which looks, through research and journalism, at the bond formed between parents and young children — a bond that plays an enormous role in a person's well-being and self-worth for the rest of their life.",
  paragraph2:
    "Each episode explores how parents, educators and other caregivers can change parts of their own behaviour and unhelpful patterns, so the child gets the best possible start in life. The podcast consists of an introduction and four episodes, each in a short and a long version.",
  paragraph3:
    "The guests are leading researchers and experts. Every episode is hosted by psychologist and researcher at the University of Southern Denmark Aida Bikic and journalist Peter Krogh Andersen.",
  episodesHeading: "Episodes",
  episodes: [
    {
      title: "Hvad kan vi lære af andre samfund?",
      duration: "46 min",
      description:
        "Parents in small Greenlandic communities are with their children around the clock. In African tribal societies the hierarchy is often strict and hard, but safe. In Denmark, busy city life makes secure attachment difficult, and it asks us to think about family in a new way. What can Denmark learn from other societies? Guest: Niels Peter Rygaard, psychologist, author and founder of Fairstart Foundation.",
    },
    {
      title: "TEASER: Hvad kan vi lære af andre samfund?",
      duration: "5 min",
      description: "Short teaser for the episode.",
    },
    {
      title: "Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "41 min",
      description:
        "Can overtraining and eating disorders in adults come from insecure attachment? Researcher and psychologist Mia Beck Lichtenstein thinks so. She often sees clients turn to extreme control of body and food when feelings are hard. Guest: Mia Beck Lichtenstein, psychologist and professor at SDU.",
    },
    {
      title: "TEASER: Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "4 min",
      description: "Short teaser for the episode.",
    },
    {
      title: "De atypiske hjerner er særligt sårbare",
      duration: "44 min",
      description:
        "The many adults in a modern childhood make secure attachment outside the home difficult. It hits children with ADHD and other atypical brains especially hard, says researcher and author Pernille Darling. Her own count shows that a child today meets up to ten times as many adults as she did in her childhood. Guest: Pernille Darling Juul, psychiatrist and researcher.",
    },
    {
      title: "TEASER: De atypiske hjerner er særligt sårbare",
      duration: "3 min",
      description: "Short teaser for the episode.",
    },
    {
      title: "Hvorfor gentager vi vores forældres fejl?",
      duration: "49 min",
      description:
        "Most of us want to avoid repeating our parents' mistakes. Still we end up doing exactly what they did, especially under pressure. Why? And what can we do to change it? Guest: Johanne Smith-Nielsen, psychologist and researcher at the University of Copenhagen.",
    },
    {
      title: "Introduktion: Hvad er tilknytning?",
      duration: "3 min",
      description:
        "What do we actually know about attachment, and why does it matter so much for a child's well-being and self-worth? A short introduction to the bond between you and your child, told by researcher and psychologist Aida Bikic.",
    },
    {
      title: "TEASER: Hvorfor gentager vi vores forældres fejl?",
      duration: "5 min",
      description: "Short teaser for the episode.",
    },
  ],
};

export const PodcastResourcesDE = {
  title: "TILKNYTNING",
  kicker: "Podcast",
  hosts: "Aida Bikic und Peter Krogh Andersen",
  captivate: "Auf Captivate hören",
  spotify: "Auf Spotify hören",
  paragraph1:
    "Warum wiederholen wir die Fehler unserer Eltern, wenn wir selbst Eltern werden? Das ist die Grundlage des Podcasts TILKNYTNING, der mit wissenschaftlichem Blick und journalistischer Führung das Band untersucht, das zwischen Eltern und kleinen Kindern entsteht und das für Wohlbefinden und Selbstwert ein Leben lang eine enorme Rolle spielt.",
  paragraph2:
    "In jeder Folge hören wir, wie Eltern, Pädagoginnen und Pädagogen und andere Bezugspersonen Teile ihres eigenen Verhaltens und ungünstiger Muster verändern können, damit das Kind den bestmöglichen Start ins Leben bekommt. Der Podcast besteht aus einer Einführung und vier Folgen, jeweils in einer kurzen und einer langen Version.",
  paragraph3:
    "Die Gäste sind führende Forschende und Expertinnen und Experten des Landes. Jede Folge wird moderiert von der Psychologin und Forscherin an der Süddänischen Universität Aida Bikic und dem Journalisten Peter Krogh Andersen.",
  episodesHeading: "Folgen",
  episodes: [
    {
      title: "Hvad kan vi lære af andre samfund?",
      duration: "46 min",
      description:
        "Eltern in kleinen grönländischen Gemeinschaften sind rund um die Uhr bei ihren Kindern. In afrikanischen Stammesgesellschaften ist die Hierarchie oft streng und hart, aber sicher. In Dänemark erschwert das hektische Großstadtleben eine sichere Bindung. Was kann Dänemark von anderen Gesellschaften lernen? Gast: Niels Peter Rygaard, Psychologe, Autor und Gründer der Fairstart Foundation.",
    },
    {
      title: "TEASER: Hvad kan vi lære af andre samfund?",
      duration: "5 min",
      description: "Kurzer Teaser zur Folge.",
    },
    {
      title: "Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "41 min",
      description:
        "Können Übertraining und Essstörungen bei Erwachsenen auf unsichere Bindung zurückgehen? Das meint die Forscherin und Psychologin Mia Beck Lichtenstein. Sie sieht oft, dass Klientinnen und Klienten zu extremer Kontrolle von Körper und Essen greifen, wenn Gefühle schwer sind. Gast: Mia Beck Lichtenstein, Psychologin und Professorin an der SDU.",
    },
    {
      title: "TEASER: Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "4 min",
      description: "Kurzer Teaser zur Folge.",
    },
    {
      title: "De atypiske hjerner er særligt sårbare",
      duration: "44 min",
      description:
        "Die vielen Erwachsenen in einer modernen Kindheit machen sichere Bindung außerhalb des Zuhauses schwer. Das trifft besonders Kinder mit ADHS und anderen atypischen Gehirnen, sagt Forscherin und Autorin Pernille Darling. Ihre eigene Zählung zeigt, dass ein Kind heute bis zu zehnmal so viele Erwachsene trifft wie sie in ihrer Kindheit. Gast: Pernille Darling Juul, Psychiaterin und Forscherin.",
    },
    {
      title: "TEASER: De atypiske hjerner er særligt sårbare",
      duration: "3 min",
      description: "Kurzer Teaser zur Folge.",
    },
    {
      title: "Hvorfor gentager vi vores forældres fejl?",
      duration: "49 min",
      description:
        "Die meisten von uns möchten die Fehler ihrer Eltern nicht wiederholen. Trotzdem tun wir genau das, was unsere Eltern taten — besonders unter Druck. Aber warum? Und was können wir ändern? Gast: Johanne Smith-Nielsen, Psychologin und Forscherin an der Universität Kopenhagen.",
    },
    {
      title: "Introduktion: Hvad er tilknytning?",
      duration: "3 min",
      description:
        "Was wissen wir eigentlich über Bindung, und warum ist sie so wichtig für das Wohlbefinden und den Selbstwert eines Kindes? Eine kurze Einführung in das Band zwischen Ihnen und Ihrem Kind, erzählt von Forscherin und Psychologin Aida Bikic.",
    },
    {
      title: "TEASER: Hvorfor gentager vi vores forældres fejl?",
      duration: "5 min",
      description: "Kurzer Teaser zur Folge.",
    },
  ],
};

export const PodcastResourcesBS = {
  title: "TILKNYTNING",
  kicker: "Podkast",
  hosts: "Aida Bikic i Peter Krogh Andersen",
  captivate: "Slušaj na Captivate",
  spotify: "Slušaj na Spotify",
  paragraph1:
    "Zašto ponavljamo greške svojih roditelja kada i sami postanemo roditelji? To je temelj podkasta TILKNYTNING, koji kroz istraživanje i novinarstvo gleda na vezu koja nastaje između roditelja i male djece i koja ima ogromnu ulogu u čovjekovoj dobrobiti i samopouzdanju tokom cijelog života.",
  paragraph2:
    "U svakoj epizodi čujemo kako roditelji, pedagozi i druge osobe koje brinu o djeci mogu promijeniti dijelove vlastitog ponašanja i nesretnih obrazaca, kako bi dijete dobilo najbolji mogući početak života. Podkast čine uvod i četiri epizode, svaka u kratkoj i dugoj verziji.",
  paragraph3:
    "Gosti su vodeći istraživači i stručnjaci. Svaku epizodu vode psihologinja i istraživačica na Univerzitetu Južne Danske Aida Bikic i novinar Peter Krogh Andersen.",
  episodesHeading: "Epizode",
  episodes: [
    {
      title: "Hvad kan vi lære af andre samfund?",
      duration: "46 min",
      description:
        "Roditelji u malim grenlandskim zajednicama su sa svojom djecom cijelo vrijeme. U afričkim plemenskim društvima hijerarhija je često stroga i tvrda, ali sigurna. U Danskoj užurbani gradski život otežava sigurnu vezanost. Šta Danska može naučiti od drugih društava? Gost: Niels Peter Rygaard, psiholog, autor i osnivač Fairstart Foundation.",
    },
    {
      title: "TEASER: Hvad kan vi lære af andre samfund?",
      duration: "5 min",
      description: "Kratki teaser epizode.",
    },
    {
      title: "Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "41 min",
      description:
        "Mogu li prekomjerni trening i poremećaji ishrane kod odraslih poticati od nesigurne vezanosti? Tako smatra istraživačica i psihologinja Mia Beck Lichtenstein, koja često vidi da klijenti posežu za ekstremnom kontrolom tijela i hrane kada su emocije teške. Gost: Mia Beck Lichtenstein, psihologinja i profesorica na SDU.",
    },
    {
      title: "TEASER: Omsorgshunger og voksne med ondt i tilknytningen",
      duration: "4 min",
      description: "Kratki teaser epizode.",
    },
    {
      title: "De atypiske hjerner er særligt sårbare",
      duration: "44 min",
      description:
        "Mnogo odraslih u modernom djetinjstvu otežava sigurnu vezanost van kuće. To posebno pogađa djecu s ADHD-om i drugim atipičnim mozgovima, kaže istraživačica i autorica Pernille Darling. Njeno brojanje pokazuje da dijete danas sretne i do deset puta više odraslih nego ona u svom djetinjstvu. Gost: Pernille Darling Juul, psihijatrica i istraživačica.",
    },
    {
      title: "TEASER: De atypiske hjerner er særligt sårbare",
      duration: "3 min",
      description: "Kratki teaser epizode.",
    },
    {
      title: "Hvorfor gentager vi vores forældres fejl?",
      duration: "49 min",
      description:
        "Većina nas želi izbjeći ponavljanje grešaka svojih roditelja. Ipak završimo radeći upravo ono što su oni radili, posebno pod pritiskom. Zašto? I šta možemo promijeniti? Gost: Johanne Smith-Nielsen, psihologinja i istraživačica na Univerzitetu u Kopenhagenu.",
    },
    {
      title: "Introduktion: Hvad er tilknytning?",
      duration: "3 min",
      description:
        "Šta zapravo znamo o vezanosti i zašto je toliko važna za djetetovu dobrobit i samopouzdanje? Kratak uvod u vezu između vas i vašeg djeteta, koji priča istraživačica i psihologinja Aida Bikic.",
    },
    {
      title: "TEASER: Hvorfor gentager vi vores forældres fejl?",
      duration: "5 min",
      description: "Kratki teaser epizode.",
    },
  ],
};
